import { createAsyncThunk } from '@reduxjs/toolkit';
import { webLinkDistributionApi } from 'container/webLinkDistributionApi';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const fetchWebLinkDistribution = createAsyncThunk(
  `${STORE_NAME}/fetchWebLinkDistribution`,
  ({ projectId }: { projectId: number }) => {
    return webLinkDistributionApi.get(projectId);
  },
  { serializeError },
);
